import React, { useRef } from "react";

import styled from 'styled-components'

export const FilterDateInputAdmin = (
    {
        label,
        labelColor = '#646363',
        onChangeItem = () => {},
        value = '',
        disabled = false,
        style= null,
        placeholder = ''
    }
) => {
    
    const ref = useRef();
    const Container = styled.div``
    const LabelContainer = styled.div`
        color: ${labelColor};
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        display: flex;
    `
    const InputContainer = styled.input`
        background: rgba(196, 196, 196, 0.1) !important;
        border: 0.5px solid #646363 !important;
        height: 26px !important;
        padding: 6px 11px;
        font-size: 14px;
        line-height: 17px;
        outline-offset: 0px;
    `
    
    
    return (
        <Container>
                <LabelContainer>
                    <label htmlFor={label}>{label}<br/></label>
                </LabelContainer>
            <>
                <InputContainer
                    ref={ref}
                    placeholder={placeholder}
                    disabled={disabled}
                    style={style}
                    value={value}
                    id="input-date"
                    name="dataInicio"
                    type="date"
                    max={'9999-12-31'}
                    onChange={onChangeItem}
                />
            </>
        </Container>
    )
}
